import i18n from '../i18n';

export const reviewOptions = [
  { value: 0, label: i18n.t('common.none') }, // we conform this to null in the payload, Qselect does not support null values
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
  { value: 6, label: '6' },
  { value: 7, label: '7' },
  { value: 8, label: '8' },
  { value: 9, label: '9' },
  { value: 10, label: '10' },
  { value: 11, label: '11' },
  { value: 12, label: '12' },
  { value: 13, label: '13' },
  { value: 14, label: '14' },
  { value: 15, label: '15' },
  { value: 16, label: '16' },
  { value: 17, label: '17' },
  { value: 18, label: '18' },
  { value: 19, label: '19' },
  { value: 20, label: '20' },
  { value: 21, label: '21' },
  { value: 22, label: '22' },
  { value: 23, label: '23' },
  { value: 24, label: '24' },
  { value: 30, label: '30' },
  { value: 36, label: '36' },
  { value: 42, label: '42' },
  { value: 48, label: '48' },
  { value: 54, label: '54' },
  { value: 60, label: '60' },
  { value: 66, label: '66' },
  { value: 72, label: '72' },
  { value: 78, label: '78' },
  { value: 84, label: '84' },
];

export const fileDownloadOptionsLabel = {
  owner: i18n.t('template.permissions.owner'),
  quality: i18n.t('template.permissions.ownerQuality'),
  normal: i18n.t('template.permissions.ownerQualityNormal'),
  read_only: i18n.t('template.permissions.ownerQualityNormalBasic'),
};

export const fileDownloadOptions = [
  { value: 'owner', label: fileDownloadOptionsLabel['owner'] },
  { value: 'quality', label: fileDownloadOptionsLabel['quality'] },
  { value: 'normal', label: fileDownloadOptionsLabel['normal'] },
  { value: 'read_only', label: fileDownloadOptionsLabel['read_only'] },
];

export const resolveFileDownloadUserGroups = (groups: string[] | undefined) => {
  if (!groups) {
    return 'owner';
  }
  if (groups.includes('read_only')) {
    return 'read_only';
  }
  if (groups.includes('normal')) {
    return 'normal';
  }
  if (groups.includes('quality')) {
    return 'quality';
  }
  return 'owner';
};

export const fileDownloadUserGroupsMap = {
  owner: [],
  quality: ['quality'],
  normal: ['quality', 'normal'],
  read_only: ['quality', 'normal', 'read_only'],
};
